import { Alert, AlertIcon, Box, Divider, Stack, Text } from '@chakra-ui/react';
import ContractTypeRadio from '../atoms/ContractTypeRadio';
import LoadingSpinner from '../atoms/LoadingSpinner';
import { useContractTypes } from '../hooks/useContractTypes';

interface ContractTypeOptionsListProps {
  selectedValue: string;
  onValueChange: (value: string) => void;
}

const ContractTypeOptionsList: React.FC<ContractTypeOptionsListProps> = ({
  selectedValue,
  onValueChange,
}) => {
  const { contractTypes, isLoading, error } = useContractTypes();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <Alert status="error" mx={8} my={4}>
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  return (
    <Box>
      <Text fontWeight="semibold" fontSize="1.25rem" pl={8} mb={6} mt={7}>
        Qual o tipo de contrato?
      </Text>
      <Stack spacing={0}>
        {contractTypes.map((option, idx) => (
          <Box key={option.value} w="100%">
            <ContractTypeRadio
              option={option}
              isChecked={selectedValue === option.value}
              onChange={() => onValueChange(option.value)}
            />
            {idx < contractTypes.length - 1 && (
              <Divider
                borderColor="gray.200"
                borderWidth="1px"
                borderStyle="solid"
                m={0}
              />
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default ContractTypeOptionsList;
